import * as XLSX from "xlsx";

const fecha = (v) => (v ? String(v).slice(0, 10) : "");
const num = (v) => {
  const n = Number(String(v ?? "").replace(/,/g, ""));
  return Number.isFinite(n) ? n : 0;
};

const COLUMNAS_EGRESO = [
  ["Fecha", "fecha"], ["N° egreso", "id"], ["N° cheque", "nocheque"], ["Concepto", "concepto"], ["Depósito a", "deposito"],
  ["Macrocuenta", "macrocuenta"], ["Contrato", "nro_contrato"], ["Referencia", "nro_referencia"], ["Factura", "nro_factura"],
  ["Servicio", "servicio"], ["Banco", "banco"], ["Mes", "mes"], ["Dirigido a", "nombre"], ["Ciudad", "ciudad"],
  ["Bs", "bolivianos"], ["$us", "dolares"], ["Nulo", "anulado"], ["Observación", "obs"], ["Cliente", "razon_social"],
];

// Convierte el resultado de un reporte en filas para una hoja de Excel: [{ nombre, filas }].
// Las cifras van como números (no como texto) para poder sumarlas en Excel.
const hojaDe = (r, items) => {
  switch (r.tipo) {
    case "egresos": {
      const filas = [COLUMNAS_EGRESO.map(([h]) => h)];
      (items || r.items).forEach((x) => filas.push(COLUMNAS_EGRESO.map(([, k]) => (k === "fecha" ? fecha(x.fecha) : k === "bolivianos" || k === "dolares" ? num(x[k]) : x[k] ?? ""))));
      const pm = r.por_moneda || {};
      filas.push([], ["Resumen de importes"], ["Moneda de emisión", "Cheques", "Importe emitido", "Equivale a Bs", "Equivale a $us"],
        ["Emitidos en Bolivianos (Bs)", num(pm.Bolivianos?.cantidad), num(pm.Bolivianos?.bolivianos), num(pm.Bolivianos?.bolivianos), num(pm.Bolivianos?.dolares)],
        ["Emitidos en Dólares ($us)", num(pm.Dolares?.cantidad), num(pm.Dolares?.dolares), num(pm.Dolares?.bolivianos), num(pm.Dolares?.dolares)],
        ["Total general", num(r.total), "", num(r.total_bolivianos), num(r.total_dolares)]);
      if (r.con_resumen_servicio) {
        const servicios = Object.keys(r.por_servicio);
        filas.push([], ["Moneda / Servicio", ...servicios, "Total"],
          ["Bolivianos", ...servicios.map((s) => num(r.por_servicio[s].bolivianos)), servicios.reduce((a, s) => a + num(r.por_servicio[s].bolivianos), 0)],
          ["Dólares", ...servicios.map((s) => num(r.por_servicio[s].dolares)), servicios.reduce((a, s) => a + num(r.por_servicio[s].dolares), 0)]);
      }
      return { nombre: "Egresos", filas };
    }
    case "resumen":
      return { nombre: "Resumen", filas: [["Egresos en", "Total en dólares americanos"], ...r.filas.map((f) => [f.area, num(f.dolares)]), ["Total", num(r.total_dolares)]] };
    case "macro_mes":
      return { nombre: "Macrocuentas", filas: [["Macrocuenta", "Bolivianos", "Dólares"], ...r.filas.map((f) => [f.macrocuenta, num(f.bolivianos), num(f.dolares)]), ["Total", num(r.total_bolivianos), num(r.total_dolares)]] };
    case "macro_year": {
      const filas = [["Macrocuenta", "Moneda", ...r.meses]];
      r.filas.forEach((f) => { filas.push([f.macrocuenta, "Bs.", ...f.bolivianos.map(num)]); filas.push(["", "$us.", ...f.dolares.map(num)]); });
      filas.push(["Total", "Bs.", ...r.total_bolivianos.map(num)], ["", "$us.", ...r.total_dolares.map(num)]);
      return { nombre: "Macrocuentas año", filas };
    }
    case "traspasos":
      return {
        nombre: "Traspasos",
        filas: [["ID", "Banco origen", "Comprobante origen", "Cheque origen", "Banco destino", "Comprobante destino", "Cheque destino", "Dólares", "Bolivianos", "Fecha"],
          ...r.items.map((x) => [x.id, x.banco_origen, x.comprobante_origen, x.num_cheque_origen, x.banco_destino, x.comprobante_destino, x.num_cheque_destino, num(x.dolares), num(x.bolivianos), fecha(x.fecha)])],
      };
    case "creditos":
      return {
        nombre: "Créditos",
        filas: [["ID", "Banco destino", "Bolivianos", "Dólares", "Moneda", "Plazo", "Comprobante", "Garantía", "Fecha", "Registrado por"],
          ...r.items.map((x) => [x.id, x.banco_destino, num(x.bolivianos), num(x.dolares), x.moneda, x.plazo, x.comprobante, x.garantia, fecha(x.fecha), x.usu])],
      };
    case "banco_anual": {
      const filas = [["", ...r.bancos.flatMap((b) => [b.replace(/_/g, " "), ""])], ["", ...r.bancos.flatMap(() => ["Bs.", "$us."])]];
      r.meses.forEach((m, i) => filas.push([m, ...r.bancos.flatMap((b) => [num(r.montos[b].bolivianos[i]), num(r.montos[b].dolares[i])])]));
      filas.push(["Total", ...r.bancos.flatMap((b) => [num(r.montos[b].total_bolivianos), num(r.montos[b].total_dolares)])]);
      return { nombre: "Bancos año", filas };
    }
    case "cuentas_monto":
      return { nombre: "Cuentas", filas: [["N° cuenta", "Nombre de la cuenta", "Bolivianos", "Dólares"], ...r.filas.map((f) => [f.cuenta, f.nombre, num(f.bolivianos), num(f.dolares)]), ["Total", "", num(r.total_bolivianos), num(r.total_dolares)]] };
    case "asientos":
      return {
        nombre: "Asientos",
        filas: [["Código", "Fecha", "Cuenta 1 (debe)", "Cuenta 2 (haber)", "Bolivianos", "Dólares", "Observación"],
          ...r.items.map((x) => [x.id, fecha(x.fecha), x.cuenta1, x.cuenta2, num(x.bolivianos), num(x.dolares), x.observacion]), ["Total", "", "", "", num(r.total_bolivianos), num(r.total_dolares)]],
      };
    case "mayor":
      return {
        nombre: "Mayor",
        filas: [["Código", "Fecha", "Debe Bs", "Debe $us", "Haber Bs", "Haber $us", "Contra cuenta", "Observación"],
          ...r.items.map((x) => [x.id, fecha(x.fecha), x.debe_bs ?? "", x.debe_usd ?? "", x.haber_bs ?? "", x.haber_usd ?? "", x.contra, x.observacion]),
          ["Totales", "", num(r.debe_bs), num(r.debe_usd), num(r.haber_bs), num(r.haber_usd)], ["Saldo", "", num(r.saldo_bs), num(r.saldo_usd)]],
      };
    case "cuenta_year": {
      const filas = [["Mes", "Bolivianos", "Dólares"], ...r.meses.map((m, i) => [m, num(r.bolivianos[i]), num(r.dolares[i])]), ["Totales", num(r.total_bolivianos), num(r.total_dolares)],
        [], ["Banco", "Emitido en Bs (Bs)", "Emitido en Bs ($us)", "Emitido en $us (Bs)", "Emitido en $us ($us)"],
        ...Object.entries(r.bancos).map(([b, v]) => [b, num(v.en_bs_bs), num(v.en_bs_usd), num(v.en_usd_bs), num(v.en_usd_usd)])];
      return { nombre: "Cuenta año", filas };
    }
    case "balance":
      return {
        nombre: "Balance",
        filas: [["Cuenta", "Bolivianos", "Dólares"],
          ...r.lineas.map((l) => (l.nivel === "seccion" ? [l.nombre.toUpperCase()] : [(l.nivel === "detalle" ? "    " : "") + l.nombre, num(l.bs), num(l.usd)]))],
      };
    default:
      return { nombre: "Reporte", filas: [["Sin datos para exportar"]] };
  }
};

// Ancho de columna según el contenido (con tope) para que el Excel se abra legible.
const anchos = (filas) => {
  const cols = Math.max(...filas.map((f) => f.length), 1);
  return Array.from({ length: cols }, (_, c) => ({ wch: Math.min(Math.max(...filas.map((f) => String(f[c] ?? "").length), 8) + 2, 50) }));
};

// Descarga el reporte mostrado como .xlsx. `items` es la lista ya filtrada y ordenada de la tabla de cheques.
export const exportarReporteExcel = (resultado, items) => {
  const { nombre, filas } = hojaDe(resultado, items);
  const datos = [[resultado.titulo || nombre], [], ...filas];
  const hoja = XLSX.utils.aoa_to_sheet(datos);
  hoja["!cols"] = anchos(filas);
  // Montos con formato 0,000.00. Una hoja puede tener varias tablas (resumen, por servicio, por mes, por banco): cada fila
  // solo de textos se toma como encabezado de lo que sigue, y se formatean todos los números salvo los de columnas de
  // identificadores o cantidades (ID, N° cheque, comprobante, cantidad de cheques, plazo).
  const NO_MONTO = /^id$|n°|nro|cheque|comprobante|referencia|contrato|factura|cantidad|plazo|a[nñ]o/i;
  let noMonto = [];
  datos.forEach((fila, r) => {
    const textos = fila.filter((v) => v !== "" && v !== null && v !== undefined);
    if (textos.length >= 2 && textos.every((v) => typeof v === "string")) {
      noMonto = fila.map((h) => NO_MONTO.test(String(h ?? "").trim()));
      return;
    }
    fila.forEach((v, c) => {
      if (typeof v !== "number" || noMonto[c]) return;
      const celda = hoja[XLSX.utils.encode_cell({ r, c })];
      if (celda) celda.z = "#,##0.00";
    });
  });
  const libro = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(libro, hoja, nombre.slice(0, 31));
  const limpio = String(resultado.titulo || nombre).replace(/[\\/:*?"<>|—]/g, "-").replace(/\s+/g, "_").slice(0, 60);
  XLSX.writeFile(libro, `${limpio}_${new Date().toISOString().slice(0, 10)}.xlsx`);
};
